import React, { useState } from 'react';
import styled from 'styled-components';

const ReviewContainer = styled.div`
  padding: 20px;
`;

const ReviewInput = styled.div`
  margin-bottom: 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 16px;
  border: 1px solid rgba(232, 232, 232, 0.38);
  border-radius: 8px;
  resize: vertical;
  font-size: 14px;
  color: #333;
  
  &::placeholder {
    color: #999;
  }
  
  &:focus {
    outline: none;
    border-color: #1890ff;
  }
`;

const ButtonContainer = styled.div`
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f0f0;
`;

const SubmitButton = styled.button`
  padding: 8px 24px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: #40a9ff;
  }
`;

const ReviewCard = styled.div`
  padding: 20px;
  border-bottom: 0.5px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ReviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

const Username = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #333;
`;

const ReviewDate = styled.span`
  font-size: 14px;
  color: #999;
`;

const ReviewContent = styled.div`
  font-size: 14px;
  color: #666;
  line-height: 1.6;
`;

// 模拟评价数据
const mockReviews = [
  {
    id: 1,
    username: '张三',
    avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
    content: '这个课程非常棒，老师讲得很清楚，内容也很实用，推荐大家学习！',
    date: '2025/5/11'
  },
  {
    id: 2,
    username: '李四',
    avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
    content: '这个课程非常棒，老师讲得很清楚，内容也很实用，推荐大家学习！',
    date: '2025/5/11'
  },
  {
    id: 3,
    username: '王五',
    avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
    content: '这个课程非常棒，老师讲得很清楚，内容也很实用，推荐大家学习！',
    date: '2025/5/11'
  }
];

const CourseReview = () => {
  const [reviewText, setReviewText] = useState('');

  const handleSubmit = () => {
    if (!reviewText.trim()) {
      alert('请输入评价内容');
      return;
    }
    // TODO: 实现评价提交逻辑
    console.log('提交评价:', reviewText);
    setReviewText('');
  };

  return (
    <ReviewContainer>
      <ReviewInput>
        <TextArea
          placeholder="请分享您对这门课程的想法和建议..."
          value={reviewText}
          onChange={(e) => setReviewText(e.target.value)}
        />
        <ButtonContainer>
          <SubmitButton onClick={handleSubmit}>
            发布评价
          </SubmitButton>
        </ButtonContainer>
      </ReviewInput>
      
      {mockReviews.map(review => (
        <ReviewCard key={review.id}>
          <ReviewHeader>
            <UserInfo>
              <Avatar src={review.avatar} alt={review.username} />
              <Username>{review.username}</Username>
            </UserInfo>
            <ReviewDate>{review.date}</ReviewDate>
          </ReviewHeader>
          <ReviewContent>{review.content}</ReviewContent>
        </ReviewCard>
      ))}
    </ReviewContainer>
  );
};

export default CourseReview; 